import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { getStringWithoutLeadingSlash } from 'helpers/parsing/stringWithoutSlash';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { useMemo } from 'react';
import { StoreLocatorStoreTypeGroups } from 'types/store';

type StoresListMetadataProps = {
    stores: StoreLocatorStoreTypeGroups;
};

export const StoresListMetadata: FC<StoresListMetadataProps> = ({ stores }) => {
    const { url } = useDomainConfig();
    const { t } = useTranslation();
    const allStores = useMemo(() => [...stores.tescoma, ...stores.partner], [stores]);
    const metadata = {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: `${t('List of stores')} TESCOMA`,
        numberOfItems: allStores.length,
        itemListElement: allStores.map((store, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            url: url + getStringWithoutLeadingSlash(store.slug),
        })),
    };

    return (
        <Head>
            <script
                key="stores-list-metadata"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(metadata).replace(/</g, '\\u003c') }}
                id="stores-list-metadata"
                type="application/ld+json"
            />
        </Head>
    );
};
